import { Component } from 'preact';
import style from './Home.scss';
import RaffleList from '../../components/raffle/RaffleList';
import Subscribe from '../../components/subscribe';
import { connect } from 'react-redux';
import RaffleCarousel from '../../components/raffle/RaffleCarousel';
import { bindActionCreators } from 'redux';
import HomepageRepository from '../../repositories/HomepageRepository';
import RaffleRepository from '../../repositories/RaffleRepository';
import Layout from '../../components/Layout';
import { HOMEPAGE_RELOAD_THRESHOLD_SECONDS } from '../../parameters';
import DateService from '../../services/DateService';
import LoadingSpinner from '../../components/spinner/LoadingSpinner';
import MetaTags from "react-meta-tags";

import {isArray} from '../../helpers/Polyfills';
/**
 * @property {object} props.activeOrComingSoonRaffles
 * @property {object} props.closedRaffles
 * @property {object} props.carouselRaffles
 * @property {Function} props.fetchClosed
 * @property {Function} props.fetchActiveOrComingSoon
 */
// eslint-disable-next-line react/prefer-stateless-function
class Home extends Component {

	static fetchData(store) {
		return [
			store.dispatch(HomepageRepository.fetchHomepageData())
		];
	}

	static getHtmlHeadFragment() {
		return '<title>Footshop - Releases</title><meta name="robots" content="index, follow"><meta name="description" content="The biggest selection of sneakers by brands such as adidas, Converse, Nike, Vans and more in stock! Shop online for great prices at Footshop.com!">';
	}

	/**
	 * Note that fetch initial data is handled separately in server.js
	 */
	componentDidMount() {
		if (!this.props.loaded || (DateService.getCurrentDateInSeconds() > (this.props.lastReload + HOMEPAGE_RELOAD_THRESHOLD_SECONDS))) {
			this.props.fetchHomepageData();
		}
	}

	get areRafflesOpened() {
		const {activeOrComingSoonRaffles} = this.props;
		return isArray(activeOrComingSoonRaffles.items) && activeOrComingSoonRaffles.items.length !== 0;
	}

	render({ route, location, activeOrComingSoonRaffles, closedRaffles, carouselRaffles, loaded, fetchClosed, fetchActiveOrComingSoon, suggestedShopId }) {
		if (!loaded) {
			return (
				<Layout {...{ route, location }}>
					<div className="abs-vertical-center">
						<LoadingSpinner active />
					</div>
				</Layout>
			);
		}
		return (
			<Layout {...{ route, location }}>
				<MetaTags>
					<title>{route.metaTitle}</title>
					<meta name="description" content=""/>
				</MetaTags>
				{this.areRafflesOpened ? (
					<div>
						<RaffleCarousel {...{ raffles: carouselRaffles.items, activeIndex: carouselRaffles.activeIndex, loaded }} />
						<div className={`container ${style['active-or-coming-soon']}`}>
							<RaffleList
								className={style['active-or-coming-soon']}
								{...activeOrComingSoonRaffles}
								fetchMore={fetchActiveOrComingSoon}
								hasPromo
								suggestedShopId={suggestedShopId}
							/>
						</div>
					</div>
				) : (
					<Subscribe />
				)}
				<div className={`container ${style.closed} `}>
					<h2>Closed raffles</h2>
					<div className={style.divider} />
					<RaffleList
						className={style['closed-list']}
						{...closedRaffles}
						fetchMore={fetchClosed}
						hasPromo={!this.areRafflesOpened}
						suggestedShopId={suggestedShopId}
					/>
				</div>
			</Layout>
		);
	}
}

const mapStateToProps = (state) => ({
	...state.homepage,
	suggestedShopId: state.ui.suggestedShopId
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
	fetchHomepageData: HomepageRepository.fetchHomepageData,
	fetchActiveOrComingSoon: RaffleRepository.fetchActiveOrComingSoon,
	fetchClosed: RaffleRepository.fetchClosed
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./routes/home/Home.js